
export default {
  name: "app-config-boletos-quest",
  data() {
    return {};
  },
};
